import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function InvestmentMethodology() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-navy via-[#0D1128] to-dark-navy font-cairo">
      <div className="fixed inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgwLDIxNywyNTUsMC4wNSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30 pointer-events-none"></div>
      
      <Navbar />

      <main className="relative">
        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6">
          <div className="container mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              كيف نوظف رأس مالك بمسؤولية
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              منهجية استثمارية شفافة ومدروسة تضمن أفضل العوائد مع إدارة فعالة للمخاطر
            </p>
          </div>
        </section>

        {/* Complete Deal Cycle */}
        <section className="py-16 px-6">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">دورة الصفقة الكاملة</h2>
              <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                سبع مراحل متكاملة لضمان نجاح كل صفقة استثمارية
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-cyan/20 rounded-full text-2xl font-bold text-neon-cyan">
                    1
                  </div>
                  <h3 className="text-xl font-bold text-white">تحديد الصفقة</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  نبحث عن فرص استثمارية مدروسة في قطاع الأجهزة الطبية والمستلزمات الطبية مع موردين وشركاء موثوقين في الأسواق العالمية.
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-cyan/20 rounded-full text-2xl font-bold text-neon-cyan">
                    2
                  </div>
                  <h3 className="text-xl font-bold text-white">تقييم المخاطر</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  تحليل شامل للمخاطر المالية والتشغيلية والقانونية قبل اتخاذ أي قرار استثماري، مع دراسة السوق والمنافسين.
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-cyan/20 rounded-full text-2xl font-bold text-neon-cyan">
                    3
                  </div>
                  <h3 className="text-xl font-bold text-white">تمويل الشراء</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  نستخدم رأس المال المتاح من المستثمرين لشراء المنتجات الطبية من الموردين المعتمدين بأفضل الأسعار التنافسية.
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-green/20 rounded-full text-2xl font-bold text-neon-green">
                    4
                  </div>
                  <h3 className="text-xl font-bold text-white">التصدير بضمانات بنكية</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  نصدر المنتجات إلى الأسواق المستهدفة مع ضمانات بنكية لحماية رأس المال والأرباح المتوقعة من أي مخاطر محتملة.
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-green/20 rounded-full text-2xl font-bold text-neon-green">
                    5
                  </div>
                  <h3 className="text-xl font-bold text-white">المتابعة اللوجستية</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  متابعة دقيقة لعمليات الشحن والتخليص الجمركي والتسليم حتى وصول المنتجات بأمان إلى العملاء النهائيين.
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-green/20 rounded-full text-2xl font-bold text-neon-green">
                    6
                  </div>
                  <h3 className="text-xl font-bold text-white">التحصيل واحتساب الأرباح</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  تحصيل المدفوعات من العملاء واحتساب الأرباح الفعلية بشفافية كاملة وفقاً للاتفاقيات المبرمة مع المستثمرين.
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300 md:col-span-2 lg:col-span-1">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-green/20 rounded-full text-2xl font-bold text-neon-green">
                    7
                  </div>
                  <h3 className="text-xl font-bold text-white">التوزيع أو إعادة الاستثمار</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  توزيع الأرباح على المستثمرين أو إعادة استثمارها في صفقات جديدة حسب رغبة المستثمر واتفاقيات الاستثمار.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Sectors and Products */}
        <section className="py-16 px-6 bg-gradient-to-b from-transparent to-dark-navy/50">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">القطاعات والمنتجات</h2>
              <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                نركز على قطاعات طبية متخصصة ذات طلب عالٍ وجودة مضمونة
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-neon-cyan/10 rounded-xl mb-4">
                  <i className="ri-lungs-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">أجهزة التنفس الصناعي</h3>
                <p className="text-gray-400 leading-relaxed">
                  أجهزة CPAP وBiPAP من أفضل العلامات التجارية العالمية مثل ResMed وBMC
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-neon-cyan/10 rounded-xl mb-4">
                  <i className="ri-heart-pulse-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">أجهزة القياس الطبية</h3>
                <p className="text-gray-400 leading-relaxed">
                  أجهزة قياس الضغط والسكر والأكسجين وغيرها من الأجهزة الطبية المنزلية
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-neon-cyan/10 rounded-xl mb-4">
                  <i className="ri-first-aid-kit-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">المستلزمات الطبية</h3>
                <p className="text-gray-400 leading-relaxed">
                  مستلزمات طبية متنوعة من قفازات وكمامات وأدوات فحص وغيرها
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* International Markets */}
        <section className="py-16 px-6">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">الأسواق الدولية</h2>
              <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                نعمل في ثلاثة أسواق رئيسية مع خطط للتوسع المستقبلي
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-red-500/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-red-500/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-red-500/10 rounded-xl mb-4">
                  <i className="ri-map-pin-line text-4xl text-red-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">تركيا</h3>
                <p className="text-gray-400 leading-relaxed mb-4">
                  سوق رئيسي منذ 2017 مع شراكات قوية وقاعدة عملاء واسعة
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-calendar-line"></i>
                  <span>منذ 2017</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-blue-500/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-500/10 rounded-xl mb-4">
                  <i className="ri-map-pin-line text-4xl text-blue-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">بلجيكا</h3>
                <p className="text-gray-400 leading-relaxed mb-4">
                  دخول حديث في 2024 مع فرص واعدة في السوق الأوروبية
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-calendar-line"></i>
                  <span>منذ 2024</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-yellow-500/30 rounded-2xl p-8 hover:shadow-lg hover:shadow-yellow-500/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-yellow-500/10 rounded-xl mb-4">
                  <i className="ri-map-pin-line text-4xl text-yellow-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">الصين</h3>
                <p className="text-gray-400 leading-relaxed mb-4">
                  شراكات مباشرة مع مصنعين صينيين لأفضل الأسعار والجودة
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-calendar-line"></i>
                  <span>منذ 2019</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Profit Calculation Method */}
        <section className="py-16 px-6 bg-gradient-to-b from-transparent to-dark-navy/50">
          <div className="container mx-auto max-w-4xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">طريقة احتساب الأرباح</h2>
              <p className="text-lg text-gray-300">
                منهجية شفافة وواضحة لحساب العوائد الاستثمارية
              </p>
            </div>

            <div className="space-y-6 mb-8">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-6 hover:border-neon-cyan/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-neon-cyan/20 rounded-full text-lg font-bold text-neon-cyan flex-shrink-0">
                    1
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">رأس المال الأولي</h3>
                    <p className="text-gray-400">
                      يتم تحديد رأس المال المستثمر في بداية كل صفقة بشكل واضح ومتفق عليه
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-6 hover:border-neon-cyan/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-neon-cyan/20 rounded-full text-lg font-bold text-neon-cyan flex-shrink-0">
                    2
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">الإيرادات المحققة</h3>
                    <p className="text-gray-400">
                      يتم احتساب إجمالي الإيرادات من بيع المنتجات بعد خصم جميع التكاليف التشغيلية
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-6 hover:border-neon-cyan/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-neon-green/20 rounded-full text-lg font-bold text-neon-green flex-shrink-0">
                    3
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">صافي الربح</h3>
                    <p className="text-gray-400">
                      الفرق بين الإيرادات المحققة ورأس المال الأولي يمثل صافي الربح الموزع
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-neon-cyan/10 to-neon-green/10 border-2 border-neon-cyan/30 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">المعادلة الحسابية</h3>
              <div className="space-y-4 text-center">
                <div className="bg-dark-navy/50 rounded-xl p-4 border border-neon-cyan/20">
                  <p className="text-xl text-white font-semibold">
                    الرصيد النهائي = رأس المال + الأرباح
                  </p>
                </div>
                <div className="bg-dark-navy/50 rounded-xl p-4 border border-neon-green/20">
                  <p className="text-xl text-white font-semibold">
                    نسبة الربح = (الأرباح ÷ رأس المال) × 100
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Legal Notice */}
        <section className="py-16 px-6">
          <div className="container mx-auto max-w-4xl">
            <div className="bg-gradient-to-br from-red-900/30 to-pink-900/30 border-2 border-red-500/50 rounded-2xl p-8 shadow-lg shadow-red-500/20">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-500/20 rounded-full flex-shrink-0">
                  <i className="ri-alert-line text-2xl text-red-400"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4">تنويه قانوني هام</h3>
                  <p className="text-gray-300 leading-relaxed">
                    <strong className="text-white">تحذير:</strong> الاستثمار في التجارة الدولية ينطوي على مخاطر. الأداء السابق لا يضمن النتائج المستقبلية. يجب على المستثمرين المحتملين إجراء العناية الواجبة الخاصة بهم واستشارة مستشارين ماليين وقانونيين مستقلين قبل اتخاذ أي قرارات استثمارية.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
